import store from "@/store"

export default function auth({ next, router, to }) {
    if(!store || !store?.state?.auth?.isLogged) {
        store?.commit('setUrlAfterLogin', to.fullPath)
        router.push('/login').catch(()=>{})
        return
    }
    if(store.state.auth.mustChangePassword && to.name !== 'ChangePassword') {
        router.push('/change-password').catch(()=>{})
        return
    }
    if((store.state.auth.pendingLegalDocuments || []).length && to.name !== 'AcceptLegalDocuments') {
        router.push('/accept-legal-documents').catch(()=>{})
        return
    }
    if(to.meta.rights && Array.isArray(to.meta.rights)) {
        to.meta.rights.forEach(item => {
            if(!store.state.auth.rights || !store.state.auth.rights.includes(item)) {
                router.push('/login').catch(()=>{})
                return
            }
        })
    }
    if(to.meta.countries && Array.isArray(to.meta.countries) && !to.meta.countries.includes(store.state.auth.serverCountry)) {
        router.push('/calendar').catch(()=>{})
        return
    }
    return next()
}
